import React, { Component } from 'react';
import MainStore from '../../../MainStore'
import AuthStore from '../../Auth/AuthStore';
import { observer } from 'mobx-react';
import Button from '@mui/material/Button';
import './users.css'
import UserAvatar from './UserAvatar';
import ProjectTypeColorBlock from './ProjectTypeColorBlock'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const Profile = observer(class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            settings: []
        };
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handleUseEmailChange = this.handleUseEmailChange.bind(this);
        this.handleExperimentChange = this.handleExperimentChange.bind(this);
        this.handleNotificationSettingsChange = this.handleNotificationSettingsChange.bind(this);
        this.getSettingsValueByCode = this.getSettingsValueByCode.bind(this);
        this.loadNotificationSettings = this.loadNotificationSettings.bind(this);
    }

    componentDidMount() {
        this.loadNotificationSettings();
    }

    handleFileUpload(e) {
        MainStore.setMaskVisible();
        var files = e.target.files;
        var token = localStorage.getItem("token");
        var data = new FormData();
        var scope = this;
        for (var i = 0; i < files.length; i++) {
            data.append('file', files.item(i));
        };

        fetch('api/User/AddAvatar', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
                scope.setState({ isInLoading: false });
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    AuthStore.setUserId(result.id);
                    window.location.reload();
                    localStorage.setItem(AuthStore.getUserId, '');
                }).catch((err) => console.log(err));
            }
        });
    }

    handleUseEmailChange(event) {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/User/ChangeEmailUse', {
            method: 'POST',
            body: JSON.stringify(event.target.checked),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    alert("Изменения применены");
                }).catch((err) => console.log(err));
            }
        });
    }

    handleExperimentChange(isActivate) {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/User/ExperimentChange', {
            method: 'POST',
            body: JSON.stringify(isActivate),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    AuthStore.setExperimentalMode(isActivate);
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleNotificationSettingsChange = code => (evt) => {
        var scope = this;
        var checked = evt.target.checked;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Notification/Save', {
            method: 'POST',
            body: JSON.stringify({ code: code, value: checked }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    var settings = scope.state.settings.slice(0);
                    var index = settings.findIndex(s => s.code === code);
                    if (index < 0) {
                        settings.push({ code: code, value: checked });
                    }
                    else {
                        settings[index].value = checked;
                    }
                    scope.setState({ settings: settings });

                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

   loadNotificationSettings() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Notification/GetSettings', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ settings: result.settings, useEmail: result.useEmail});
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    getSettingsValueByCode(code) {
        if (!this.state.settings) return true;
        var index = this.state.settings.findIndex(s => s.code === code);
        if (index < 0) return true;
        return this.state.settings[index].value;
    }

    render() {
        return (
            <div>
                Мой профиль
                <UserAvatar userId={AuthStore.getUserId} />

                <input
                    accept="image/*"
                    id="contained-button-file"
                    onChange={this.handleFileUpload}
                    multiple
                    hidden
                    type="file"
                />
                <label htmlFor="contained-button-file">
                    <Button variant="contained" component="span">
                        Загрузить
                    </Button>
                </label>
                <div>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={this.state.useEmail}
                            onChange={this.handleUseEmailChange}
                            value="useEmail"
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }}
                        />}
                        label="Я хочу получать email уведомления"
                    />
                </div>
                <div>
                    {!AuthStore.getUseExperimentalMode && <Button variant="contained" component="span" onClick={() => { this.handleExperimentChange(true) }}>
                        Включить экспериментальный режим
                    </Button>}

                    {AuthStore.getUseExperimentalMode && <Button variant="contained" component="span" onClick={() => { this.handleExperimentChange(false) }}>
                        Выключить экспериментальный режим
                    </Button>}
                </div>

                <div style={{ display: "grid"}}>
                    <h1>Настройка уведомлений по задачам</h1>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("All")}
                                onChange={this.handleNotificationSettingsChange("All")}
                                value="All"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать все уведомления"
                    />

                    <h1>Настройка уведомлений по задачам где я ответственный</h1>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("Assignee")}
                                onChange={this.handleNotificationSettingsChange("Assignee")}
                                value="Assignee"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении ответственного"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("Status")}
                                onChange={this.handleNotificationSettingsChange("Status")}
                                value="Status"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении состояний"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("Flag")}
                                onChange={this.handleNotificationSettingsChange("Flag")}
                                value="Flag"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении флага"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("Priority")}
                                onChange={this.handleNotificationSettingsChange("Priority")}
                                value="Priority"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении приоритета"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("Comment")}
                                onChange={this.handleNotificationSettingsChange("Comment")}
                                value="Comment"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления о добавлении коментариев"
                    />

                    <h1>Настройка уведомлений по задачам где я тестировщик</h1>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("AssigneeTester")}
                                onChange={this.handleNotificationSettingsChange("AssigneeTester")}
                                value="AssigneeTester"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении ответственного"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("StatusTester")}
                                onChange={this.handleNotificationSettingsChange("StatusTester")}
                                value="StatusTester"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении состояний"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("FlagTester")}
                                onChange={this.handleNotificationSettingsChange("FlagTester")}
                                value="FlagTester"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении флага"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("PriorityTester")}
                                onChange={this.handleNotificationSettingsChange("PriorityTester")}
                                value="PriorityTester"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении приоритета"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("CommentTester")}
                                onChange={this.handleNotificationSettingsChange("CommentTester")}
                                value="CommentTester"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления о добавлении коментариев"
                    />

                    <h1>Настройка уведомлений по задачам где я создатель</h1>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("AssigneeCreator")}
                                onChange={this.handleNotificationSettingsChange("AssigneeCreator")}
                                value="AssigneeCreator"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении ответственного"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("StatusCreator")}
                                onChange={this.handleNotificationSettingsChange("StatusCreator")}
                                value="StatusCreator"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении состояний"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("FlagCreator")}
                                onChange={this.handleNotificationSettingsChange("FlagCreator")}
                                value="FlagCreator"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении флага"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("PriorityCreator")}
                                onChange={this.handleNotificationSettingsChange("PriorityCreator")}
                                value="PriorityCreator"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления об изменении приоритета"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.getSettingsValueByCode("CommentCreator")}
                                onChange={this.handleNotificationSettingsChange("CommentCreator")}
                                value="CommentCreator"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Я хочу получать уведомления о добавлении коментариев"
                    />

                </div>

                <div>
                    {false && <ProjectTypeColorBlock />}
                </div>
            </div>
        );
    }
})

export default Profile;